import equipmentColumn from '@/activities/handsontable/columns/equipment';
import { ColumnSettingsSubtable } from '@/shared/handsontable/rework/features/nestedTable/types';

const equipment: ColumnSettingsSubtable = {
  ...equipmentColumn,
  readOnly: true,
};

export default equipment;
